import React, { useState, useEffect, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { DashboardOutlined, GroupOutlined, HelpOutline, LocalHospitalOutlined, Menu, } from '@material-ui/icons';
//import { Lens } from '@material-ui/icons';
import { useHistory } from 'react-router-dom';
import { analistaFichaTecnica } from 'routes/routesGroups';
import { menusSection } from '../menus.dynamic.sidebar';
import { useLocation } from 'react-router';
import { useSelector } from 'react-redux';
import { getFichaTecnica, getPrestIntSer } from 'services/api';
import ImportContactsIcon from '@material-ui/icons/ImportContacts';
/* import { Button, Grid } from '@material-ui/core'; */
import { ordenarEquipamientoGeneralPrimero, removeDuplicates, removeNulls } from 'routes/Pages/FichasTecnicas/ConstsAndUtils/utils';
import { GESTION_C_I, GESTION_EQ, GESTION_FT, GESTION_PER, PRIVADOS, TEXT_COLOR_FT } from 'config/config';
import LayoutContext from '../../../../../@coremat/CmtLayouts/LayoutContext';
import PictureInPictureIcon from 'icons/PictureInPictureIcon';
import IconsSend from 'icons/IconsSend';



/* const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        position: 'relative',
        height: '100%',
        flexDirection: 'column'
    },
    menu: {
        width: '300px',
        backgroundColor: '#fff',
        color: '#000',
        transition: 'width 0.3s ease',
    },
    submenuContainer: {
        position: 'absolute',
        top: 0, //aca se ve el top del submenu
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: '#fff',
        color: '#000',
        animationDuration: '0.3s',
        animationTimingFunction: 'ease',
        animationFillMode: 'both',
        overflowX: 'hidden',
    },

    scrollableSubMenu: {
        maxHeight: 'calc(100% - 200px)',
        overflowY: 'auto',
        '&::-webkit-scrollbar': {
            width: 0,
        },
        '&::-webkit-scrollbar-thumb': {
            background: 'lightgrey',
            borderRadius: '5px',
        },
        '&::-webkit-scrollbar-track': {
            background: 'transparent',
            borderRadius: '5px',
        },
        '&:hover::-webkit-scrollbar': {
            width: 5,
        },
    },
    backButton: {
        padding: '10px',
        backgroundColor: 'white',
        color: TEXT_COLOR_FT,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
    },
    backButtonOpen: {

        backgroundColor: 'white',
        color: TEXT_COLOR_FT,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    itemNameTitle: {
        padding: '10px',
        backgroundColor: 'white',
        color: TEXT_COLOR_FT,
        cursor: 'context-menu',
        display: 'flex',
        alignItems: 'center',
    },
    itemNameTitleOpen: {
        padding: '5px',
        backgroundColor: 'white',
        color: TEXT_COLOR_FT,
        cursor: 'context-menu',
        display: 'flex',
        alignItems: 'center',
    },
    menuItem: {
        display: 'flex',
        padding: '10px',
        paddingLeft: '25px',
        cursor: 'pointer',
        backgroundColor: 'white',
        color: TEXT_COLOR_FT,
        //borderBottom: '1px solid #ccc',
        transition: 'background-color 0.3s ease, color 0.3s ease',
        '&:hover': {
            backgroundColor: '#E9F2FF',
        },
    },
    menuItemOpen: {
        display: 'flex',
        padding: 5,
        cursor: 'pointer',
        backgroundColor: 'white',
        color: TEXT_COLOR_FT,
        //borderBottom: '1px solid #ccc',
        transition: 'background-color 0.3s ease, color 0.3s ease',
        '&:hover': {
            backgroundColor: '#E9F2FF',
        },
    },
    selectedItem: {
        position: 'relative',
        backgroundColor: '#E9F2FF',
        color: '#0C66E4',
        transition: 'background-color 0.3s ease, color 0.3s ease',
        '&::before': {
            content: '""',
            position: 'absolute',
            left: 0,
            top: '25%',
            bottom: '25%',
            width: '5px',
            backgroundColor: '#0C66E4',
            borderTopRightRadius: '8px',
            borderBottomRightRadius: '8px',
        },
    },
    headerIcon: {
        borderRadius: 20,
        backgroundColor: TEXT_COLOR_FT,
        color: 'white',
        marginRight: '10px',
        fontSize: 18
    },
    headerIconOpen: {
        justifyContent: 'center'
    },
    slideInRightAnimation: {
        animation: '$slideInRight 0.3s ease',
    },
    slideOutLeftAnimation: {
        animation: '$slideOutLeft 0.3s ease',
    },
    '@keyframes slideInRight': {
        from: {
            transform: 'translateX(100%)',
        },
        to: {
            transform: 'translateX(0)',
        },
    },
    '@keyframes slideOutLeft': {
        from: {
            transform: 'translateX(100%)',
        },
        to: {
            transform: 'translateX(0)',
        },
    },
})); */

const ACTIVE_BG = '#EDE9FE';
const ACTIVE_FG = '#6C5CE7';
const HOVER_BG = '#F4F0FF';
const TEXT_FG = '#5F6368';
const HELP_BLUE = '#0C66E4';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        position: 'relative',
        height: '100%',
        flexDirection: 'column'
    },
    menu: {
        width: '300px',
        backgroundColor: '#fff',
        color: TEXT_FG,
        transition: 'width 0.3s ease',
    },
    submenuContainer: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: '#fff',
        color: TEXT_FG,
        animationDuration: '0.3s',
        animationTimingFunction: 'ease',
        animationFillMode: 'both',
        overflowX: 'hidden',
    },

    backButton: {
        padding: '10px',
        backgroundColor: '#f5f5f5',
        color: TEXT_FG,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
    },
    backButtonOpen: {
        backgroundColor: '#f5f5f5',
        color: TEXT_FG,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },

    itemNameTitle: {
        padding: '10px',
        backgroundColor: '#fff',
        color: TEXT_FG,
        cursor: 'context-menu',
        display: 'flex',
        alignItems: 'center',
    },
    itemNameTitleOpen: {
        padding: '5px',
        backgroundColor: '#fff',
        color: TEXT_FG,
        cursor: 'context-menu',
        display: 'flex',
        alignItems: 'center',
    },

    menuItem: {
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        padding: '12px 16px',
        margin: '6px 10px',
        borderRadius: 10,
        cursor: 'pointer',
        backgroundColor: '#fff',
        color: TEXT_FG,
        transition: 'background-color 0.2s ease, color 0.2s ease',
        '&:hover': {
            backgroundColor: HOVER_BG,
            color: ACTIVE_FG
        },
    },
    menuItemOpen: {
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        padding: '10px 12px',
        margin: '6px 10px',
        borderRadius: 10,
        cursor: 'pointer',
        backgroundColor: '#fff',
        color: TEXT_FG,
        transition: 'background-color 0.2s ease, color 0.2s ease',
        '&:hover': {
            backgroundColor: HOVER_BG,
        },
    },

    selectedItem: {
        backgroundColor: ACTIVE_BG,
        color: ACTIVE_FG,
        borderRadius: 10,
        '& svg': {
            color: ACTIVE_FG,
        },
    },

    helpItem: {
        color: '#0C66E4',
        '& svg': {
            color: '#0C66E4',
        },
    },

    headerIcon: {
        borderRadius: 20,
        backgroundColor: ACTIVE_FG,
        color: '#fff',
        marginRight: '10px',
        fontSize: 18
    },
    headerIconOpen: {
        justifyContent: 'center'
    },

    slideInRightAnimation: {
        animation: '$slideInRight 0.3s ease',
    },
    slideOutLeftAnimation: {
        animation: '$slideOutLeft 0.3s ease',
    },
    '@keyframes slideInRight': {
        from: {
            transform: 'translateX(100%)',
        },
        to: {
            transform: 'translateX(0)',
        },
    },
    '@keyframes slideOutLeft': {
        from: {
            transform: 'translateX(100%)',
        },
        to: {
            transform: 'translateX(0)',
        },
    },
}));


const getIdentificacion = (tipo) => {
    if (tipo === PRIVADOS) {
        return {
            name: 'Datos Generales',
            type: 'collapse',
            children: [
                {
                    name: 'Identificación Prestador',
                    type: 'item',
                    link: '/ft-identificacion-prestador',
                },
                {
                    name: 'Acreditación',
                    type: 'item',
                    link: '/ft-acreditacion',
                },
                {
                    name: 'Representantes / Encargados(as)',
                    type: 'item',
                    link: '/ft-representantes-encargados',
                },
                {
                    name: 'Directorio del prestador',
                    type: 'item',
                    link: '/ft-directorio-del-prestador',
                },

            ],
        }
    } else {
        return {
            name: 'Datos Generales',
            type: 'collapse',
            children: [
                {
                    name: 'Identificación Prestador',
                    type: 'item',
                    link: '/ft-identificacion-prestador',
                },
                {
                    name: 'Acreditación',
                    type: 'item',
                    link: '/ft-acreditacion',
                },
                {
                    name: 'Representantes / Encargados(as)',
                    type: 'item',
                    link: '/ft-representantes-encargados',
                },

            ],
        }
    }
}

const childrenDotacion = () => {
    return [
        {
            name: 'Carga masiva',
            type: 'item',
            link: '/ft-dp-carga-masiva',

        },
        {
            name: 'Dotación de personal',
            type: 'item',
            link: '/ft-dp-dotacion-personal',
        }
    ]
}

const Sidebar = () => {
    const classes = useStyles();
    const { user } = useSelector(({ claveUnica }) => claveUnica);
    const [menuStack, setMenuStack] = useState([]);
    const [selectedItem, setSelectedItem] = useState('Identificación Prestador');
    const [menu, setMenu] = useState([])
    const location = useLocation();
    const history = useHistory();
    //  const { isSidebarOpen } = useContext(LayoutContext);


    useEffect(() => {
        var auxUser = {};
        try {
            auxUser = JSON.parse(user);
        } catch (error) {
            auxUser = user;
        }

        if (analistaFichaTecnica.includes(location.pathname)) {

            let menu = []
            if (!!!sessionStorage.getItem('dynamicMenu')) {

                getFichaTecnica(auxUser.organization.name)
                    .then(res => {
                        sessionStorage.setItem('region', res.data.identidad.region_desc.id)
                        sessionStorage.setItem('idFicha', res.data.id)
                        const { id_tipo_prestador, tipo_atencion, tipo_administracion } = res.data.identidad
                        sessionStorage.setItem("tipo_atencion", tipo_atencion.tipo_atencion)
                        sessionStorage.setItem("tipo_administracion", tipo_administracion.tipo_administracion)
                        let aux = {
                            i: res.data.identidad.id_prestador,
                            r: res.data.identidad.rut_prestador
                        }

                        sessionStorage.setItem('prft', JSON.stringify(aux))
                        // sessionStorage.setItem("tipo_prestador", id_tipo_prestador)

                        if (!!id_tipo_prestador) {

                            getPrestIntSer(id_tipo_prestador)
                                .then(res2 => {

                                    const roles = new Set(auxUser.roles_user.map(e => e.name));

                                    const fullAccess = roles.has(GESTION_FT);

                                    const orderedMenu = [
                                        {
                                            key: 'identificacion',
                                            condition: () => fullAccess,
                                            item: getIdentificacion(tipo_administracion.tipo_administracion),
                                        },
                                        {
                                            key: 'capacidad',
                                            condition: () => fullAccess || roles.has(GESTION_C_I),
                                            item: {
                                                name: 'Capacidad Instalada',
                                                type: 'collapse',
                                                children: getCapacidadInstaladaChildren(res2.data.servicios_medicos, id_tipo_prestador),
                                            }
                                        },
                                        {
                                            key: 'equipamiento',
                                            condition: () => fullAccess || roles.has(GESTION_EQ),
                                            item: {
                                                hasArrow: false,
                                                name: "Equipamiento",
                                                type: 'collapse',
                                                children: getEquipamientoChildren(res2.data.servicios_medicos, id_tipo_prestador),
                                            }
                                        },
                                        {
                                            key: 'dotacion',
                                            condition: () => fullAccess || roles.has(GESTION_PER),
                                            item: {
                                                name: "Dotación Personal",
                                                type: 'collapse',
                                                //link: '/ft-dotacion-personal',
                                                children: childrenDotacion()
                                            }
                                        },
                                        {
                                            key: 'enviar',
                                            condition: () => fullAccess,
                                            item: { name: "Enviar Ficha Técnica", type: 'item', link: '/ft-enviar' }
                                        },
                                        {
                                            key: 'ayuda',
                                            condition: () => true,
                                            item: { name: "Ayuda", type: 'item', link: '/ft-ayuda' }
                                        }
                                    ];

                                    const menuFichasTecnicasDinamico = orderedMenu
                                        .filter(entry => entry.condition())
                                        .map(entry => entry.item);

                                    setMenu(menuFichasTecnicasDinamico)

                                    const serializeMenu = (menu) => {
                                        const serializedMenu = JSON.stringify(menu, (key, value) => {
                                            return value;
                                        });
                                        return serializedMenu;
                                    };
                                    const serializedMenu = serializeMenu(menuFichasTecnicasDinamico);
                                    sessionStorage.setItem('dynamicMenu', serializedMenu)
                                })
                                .catch(e2 => console.error(e2))
                                .finally(f => { })
                        } else {
                            menu.push({
                                name: 'Datos Generales de Identificación',
                                type: 'collapse',
                                children: [
                                    {
                                        name: 'Identificación Prestador',
                                        type: 'item',
                                        link: '/ft-identificacion-prestador',
                                    },
                                    {
                                        name: 'Acreditación',
                                        type: 'item',
                                        link: '/ft-acreditacion',
                                    },
                                    {
                                        name: 'Representantes / Encargados(as)',
                                        type: 'item',
                                        link: '/ft-representantes-encargados',
                                    },
                                ],
                            },);
                        }
                        setMenu(menu)
                    })
                    .catch(e => {
                        console.error(e)
                    })
                    .finally(() => { });
            } else {
                const deserializedMenu = JSON.parse(sessionStorage.getItem('dynamicMenu'), (key, value) => {
                    return value;
                });
                setMenu(deserializedMenu);
            }

        } else {
            setMenu(menusSection(auxUser, location.pathname));
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user, location]);

    const getSubmenuChildren = (item, prestador) => {
        if (item.espacios && item.espacios.length > 0) {
            return getSubmenu(item.espacios, item.id, prestador)
        } else {
            return getSubmenu(item.servicios_internos, item.id, prestador)
        }
    }

    const ponerCentroMedicoPrimero = (data) => {
        if (!data || !data.servicios_internos || !Array.isArray(data.servicios_internos)) {
            console.error("Invalid data structure");
            return data;
        }

        const index = data.servicios_internos.findIndex(item => item.nombre === "Centro Médico" || item.nombre === "Centro Médico Dependiente");

        if (index !== -1 && index !== 0) {
            const [centroMedico] = data.servicios_internos.splice(index, 1);
            data.servicios_internos.unshift(centroMedico);
        }

        return data;
    }

    const ponerCentrosDependientesPrimero = (data) => {

        const index = data.findIndex(item => item.nombre === "Centros Dependientes");

        if (index !== -1 && index !== 0) {
            const [centroMedico] = data.splice(index, 1);
            data.unshift(centroMedico);
        }

        return data;
    }

    /*     const ordenarEquipamientoGeneralPrimero = (data) => {
    
            const index = data.findIndex(item => NOM_LOGICO_EQUIPAMIENTO_GENERAL.includes(item.nombre_logico))
            if (index !== -1 && index !== 0) {
                const [euipamientoGeneral] = data.splice(index, 1);
                data.unshift(euipamientoGeneral);
            }
            return data
        } */

    const getSubmenu = (serviceArr, idPadre = null, prestador) => {

        let resultArr = serviceArr.map((item, index) => {
            if (!item.is_equip) {
                if (!!item.tipo_prestadores_institucional.find(e => e.id === parseInt(prestador))) {

                    if (item.is_servicio_padre) {

                        let aux = ponerCentroMedicoPrimero(item)
                        return {
                            name: item.nombre,
                            type: 'collapse',
                            children: getSubmenuChildren(aux, prestador),
                            id: item.id,
                        }
                    } else {
                        return {
                            name: item.nombre,
                            type: 'item',
                            link: '/ft-' + item.nombre.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, '').replace(/ /g, '-').replace(/[()]/g, '').trim(),
                            id: item.id,
                            parentId: (typeof idPadre === 'number' && !Number.isNaN(idPadre)) ? idPadre : serviceArr[index].id,
                        }
                    }
                } else {
                    return null
                }
            }
            return null
        })


        return resultArr

    }

    /*     const removeNulls = (obj) => {
            if (Array.isArray(obj)) {
                return obj
                    .filter(item => ((item !== null) && (item !== undefined)))
                    .map(item => removeNulls(item));
            } else if (typeof obj === 'object' && obj !== null && obj !== undefined) {
                Object.keys(obj).forEach(key => {
                    obj[key] = removeNulls(obj[key]);
                });
            }
            return obj;
        }
    
    
        const removeDuplicates = (arr) => {
    
            let auxIds = [];
    
            arr.forEach((item) => {
                if (item.is_servicio_padre) {
                    auxIds = auxIds.concat(item.servicios_internos.map((hijo) => hijo.id));
                }
            });
    
            return arr.filter((item) => !auxIds.includes(item.id));
        }; */


    const getCapacidadInstaladaChildren = (servicios, prestador) => {

        let auxservs = removeDuplicates(servicios)

        let aux = [
            {
                name: 'Autorización Sanitaria',
                type: 'item',
                link: '/ft-autorizacion-sanitaria',
            },
        ]

        let serviciosOrdenados = ponerCentrosDependientesPrimero(auxservs)

        let aux2 = [...aux, ...getSubmenu(serviciosOrdenados, aux, prestador)]

        let aux3 = removeNulls(aux2)

        return removeNulls(aux3)

    }

    const getEquipamientoChildren = (servicios, prestador) => {

        let auxservs = removeDuplicates(servicios)
        let auxservs2 = ordenarEquipamientoGeneralPrimero(auxservs)
        let auxArr2 = [
            {
                name: "Carga masiva",
                type: 'item',
                link: '/ft-eq-carga-equipamiento',
            }
        ]

        auxservs2.map((servicio, index) => {


            if (servicio.nombre_logico !== "servicio-apoyo" && !servicio.is_equip) {

                if (servicio.equipamiento.length > 0) {
                    auxArr2.push({
                        name: servicio.nombre,
                        type: 'item',
                        link: '/ft-eq-' + servicio.nombre_logico.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, '').replace(/ /g, '-').trim(),
                        id: servicio.id
                    })
                }

            } else if (servicio.is_equip) {

                if (!!servicio.tipo_prestadores_institucional.find(e => e.id === parseInt(prestador))) {
                    if (servicio.equipamiento.length > 0) {
                        auxArr2.push({
                            name: servicio.nombre,
                            type: 'item',
                            link: '/ft-eq-' + servicio.nombre_logico.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, '').replace(/ /g, '-').trim(),
                            id: servicio.id
                        })
                    }
                }

            }
            else {

                servicio.servicios_internos.map((servicio_interno, index2) => {
                    if (servicio_interno.equipamiento.length > 0) {
                        auxArr2.push({
                            name: servicio_interno.nombre,
                            type: 'item',
                            link: '/ft-eq-' + servicio_interno.nombre_logico.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, '').replace(/ /g, '-').trim(),
                            id: servicio_interno.id
                        })
                    }

                    return null
                })


            }
            return null
        })
        return auxArr2
    }

    const handleMenuClick = (menuItem) => {

        if (menuItem.type === 'item') {
            history.push(menuItem.link);
            setSelectedItem(menuItem.name);
        } else if (menuItem.type === 'collapse') {
            if (menuItem.children.length > 0) {
                sessionStorage.setItem('idNav', menuItem.children[0].id)
                sessionStorage.setItem('parentIdNav', menuItem.children[0].parentId)
                setMenuStack([...menuStack, menuItem]);
                history.push(menuItem.children[0].link);
                setSelectedItem(menuItem.children[0].name);
            }
        }
    };

    const handleBackClick = () => {
        setMenuStack(menuStack.slice(0, -1));
    };

    return (
        <div className={classes.root}>
            {/*             {isSidebarOpen ? <p
                style={{
                    paddingLeft: 25,
                    paddingRight: 25,
                    paddingTop: 24,
                    paddingBottom: 24,
                    fontSize: 10,
                    fontWeight: 400,
                    letterSpacing: '1.5px',
                    fontFamily: 'Roboto',
                    color: TEXT_COLOR_FT,
                }}
            >
                ANALISTA
            </p> :
                null
            } */}
            <MainMenu
                menuData={menu}
                handleMenuClick={handleMenuClick}
                classes={classes}
                selectedItem={selectedItem}
            />
            {menuStack.length > 0 && (
                <SubMenu
                    menuItem={menuStack[menuStack.length - 1]}
                    handleBackClick={handleBackClick}
                    handleMenuClick={handleMenuClick}
                    classes={classes}
                    menuStack={menuStack}
                    selectedItem={selectedItem}
                />
            )}
            {/*             <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="flex-end"
                style={{ position: 'fixed', bottom: 0, left: 0, padding: '10px' }}
            >
                <Grid item>
                    <Button
                        variant="outlined"
                      
                        style={{ width: 280,
                        color:'white',
                        backgroundColor:'green'
                         }}
                    >
                        <Grid container justifyContent='flex-end'>
                            enviar
                        </Grid>
                        <Grid container justifyContent='flex-end'>

                            <Send />
                        </Grid>

                    </Button>
                </Grid>
            </Grid> */}
        </div>
    );
};

const getMenuIcon = (index) => {
    if (index === 0) {
        return <DashboardOutlined fontSize='small' style={{ padding: 0, marginRight: 5 }} />
    }
    if (index === 1) {
        return <LocalHospitalOutlined fontSize='small' style={{ padding: 0, marginRight: 5 }} />
    }
    if (index === 2) {
        return <PictureInPictureIcon fontSize='small' style={{ padding: 0, marginRight: 5 }} />
    }
    if (index === 3) {
        return <GroupOutlined fontSize='small' style={{ padding: 0, marginRight: 5 }} />
    }
    if (index === 4) {
        return <IconsSend fontSize='small' style={{ padding: 0, marginRight: 5 }} />
    }
    if (index === 5) {
        return <HelpOutline fontSize='small' style={{ padding: 0, marginRight: 5 }} />
    }
}

const MainMenu = ({ menuData, handleMenuClick, classes, selectedItem }) => {
    const { isSidebarOpen } = useContext(LayoutContext);

    return (
        <div className={classes.menu}>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                {menuData.map((menuItem, index) => (
                    <li
                        key={index}
                        onClick={() => handleMenuClick(menuItem)}
                        className={[
                            classes.menuItem,
                            menuItem.name === selectedItem ? classes.selectedItem : '',
                            menuItem.name === 'Ayuda' ? classes.helpItem : '',
                        ].join(' ')}
                    >
                        {getMenuIcon(index)}
                        {isSidebarOpen ? (
                            <p style={{ fontSize: 14 }}>{menuItem.name}</p>
                        ) : null}
                    </li>
                ))}
            </ul>
        </div>
    );
};


const SubMenu = ({ menuItem, handleBackClick, handleMenuClick, classes, menuStack, selectedItem }) => {

    //const animationDirection = menuStack.length > 1 ? 'slideInRightAnimation' : 'slideOutLeftAnimation';

    const animationDirection = (menuStack.length > 1 && menuStack.length % 2 === 0) ? 'slideInRightAnimation' : 'slideOutLeftAnimation';

    const subMenuClasses = `${classes.submenuContainer} ${classes[animationDirection]}`;
    const { isSidebarOpen } = useContext(LayoutContext);

    return (
        <div className={subMenuClasses}>
            <div >


                <div onClick={handleBackClick} className={isSidebarOpen ? classes.backButton : classes.backButtonOpen}>
                    <ArrowBackIcon />
                    {isSidebarOpen ?

                        <p style={{ marginLeft: 10, fontSize: '1rem' }}>{menuStack.length === 1 ?
                            //'Menú principal'
                            'Volver'
                            :
                            // 'Menú ' + menuStack[menuStack.length - 2].name
                            'Volver'
                        }
                        </p>
                        :
                        null
                    }
                    {

                        // <h3 style={{ marginLeft: 10 }}>{menuStack.length === 1 ? 'Menú principal' : 'Menú ' + menuStack[menuStack.length - 2].name}</h3>
                    }
                </div>
                {/*                 <div className={isSidebarOpen ? classes.itemNameTitle : classes.itemNameTitleOpen}>
                    <p style={{ marginLeft: isSidebarOpen ? 20 : 0, fontSize: isSidebarOpen ? 15 : 10, fontWeight: 'bold', textDecoration: 'underline' }}>{menuItem.name}</p>
                </div> */}


            </div>
            <div className={classes.scrollableSubMenu}>
                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                    {menuItem.children && menuItem.children.map((submenuItem, index) => (
                        <li key={index} onClick={() => {
                            if (submenuItem.parentId) {
                                sessionStorage.setItem('idNav', submenuItem.id)
                                sessionStorage.setItem('parentIdNav', submenuItem.parentId)
                            } else {
                                sessionStorage.setItem('idNav', submenuItem.id)
                            }
                            handleMenuClick(submenuItem)
                        }} className={
                            isSidebarOpen ?
                                `${classes.menuItem} ${submenuItem.name === selectedItem ? classes.selectedItem : ''}`
                                :
                                `${classes.menuItemOpen} ${submenuItem.name === selectedItem ? classes.selectedItem : ''}`
                        }>
                            {isSidebarOpen ?
                                <Menu fontSize='small' style={{ marginRight: 5 }} />
                                :
                                null
                            }
                            <p style={{ fontSize: isSidebarOpen ? 14 : 10 }}>{submenuItem.name}</p>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};




export default Sidebar;

